import { useState } from 'react';
import { motion } from 'framer-motion';
import {
  FaRegBuilding,
  FaEnvelope,
  FaPhone,
  FaPaperPlane,
  FaCheckCircle,
} from 'react-icons/fa';
import QueryForm from '../components/Sectors/QueryForm';

/* ==================== THEME HELPERS ==================== */
const SERIF = { fontFamily: '"Playfair Display", Georgia, serif' };

/* ==================== CONTACT DATA ==================== */
const CONTACT = {
  name: 'Santosh Mathew',
  title: 'Senior Director & Head - International Affairs',
  email: 'international.division@assocham.com',
  phone: '011-46550555',
  phoneHref: '01146550555', // tel: link (no spaces / dashes)
  address: {
    city: 'New Delhi',
    lines: [
      'ASSOCHAM Corporate Office',
      '4th Floor, YMCA Cultural Centre & Library Building',
      '01, Jai Singh Road, New Delhi – 110001',
    ],
  },
};

const mapsUrl = (office) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    [office.lines.join(', '), office.city].filter(Boolean).join(', ')
  )}`;

/* ==================== QUERY FORM ==================== */
/* NOTE: If you already have a shared <QueryForm /> component, delete this
   local one and import yours instead — the props/API are self-contained. */
// function QueryForm() {
//   const [sent, setSent] = useState(false);
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     organisation: '',
//     country: '',
//     phone: '',
//     subject: '',
//     message: '',
//   });

//   const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const subject = `International Query — ${form.subject || form.name || 'ASSOCHAM'}`;
//     const body = [
//       `Name: ${form.name}`,
//       `Email: ${form.email}`,
//       `Organisation: ${form.organisation}`,
//       `Country: ${form.country}`,
//       `Phone: ${form.phone}`,
//       '',
//       form.message,
//     ].join('\n');

//     window.location.href = `mailto:${CONTACT.email}?subject=${encodeURIComponent(
//       subject
//     )}&body=${encodeURIComponent(body)}`;

//     setSent(true);
//   };

//   const inputCls =
//     'w-full rounded-xl border border-stone-200 bg-[#FFFBF7] px-3.5 py-2.5 text-[13px] text-stone-800 placeholder-stone-400 outline-none transition focus:border-[#C0262D] focus:ring-2 focus:ring-[#C0262D]/15';
//   const labelCls =
//     'mb-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-stone-500';

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 18 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       viewport={{ once: true }}
//       transition={{ delay: 0.1 }}
//       className="w-full rounded-2xl border border-stone-100 bg-white p-6 shadow-sm sm:p-7"
//     >
//       <h3 className="mb-1 text-xl font-bold text-stone-900" style={SERIF}>
//         Send us a <span className="text-[#DA2128]">Query</span>
//       </h3>
//       <p className="mb-6 text-[12.5px] leading-relaxed text-stone-500">
//         Fill in the details below and the International Division will get back to you within 48
//         hours.
//       </p>

//       {sent ? (
//         <div className="flex flex-col items-center justify-center rounded-xl border border-emerald-100 bg-emerald-50/60 px-6 py-10 text-center">
//           <FaCheckCircle className="mb-3 h-8 w-8 text-emerald-600" />
//           <p className="text-[14px] font-bold text-stone-900">Thank you!</p>
//           <p className="mt-1 text-[12.5px] text-stone-600">
//             Your mail client has been opened with your query. If it didn&apos;t open, write to{' '}
//             <a
//               href={`mailto:${CONTACT.email}`}
//               className="font-bold text-[#C0262D] hover:underline"
//             >
//               {CONTACT.email}
//             </a>
//             .
//           </p>
//         </div>
//       ) : (
//         <form onSubmit={handleSubmit} className="space-y-4 font-sans">
//           <div className="grid gap-4 sm:grid-cols-2">
//             <div>
//               <label className={labelCls} htmlFor="ic-name">
//                 Full Name *
//               </label>
//               <input
//                 id="ic-name"
//                 required
//                 value={form.name}
//                 onChange={update('name')}
//                 placeholder="Your name"
//                 className={inputCls}
//               />
//             </div>
//             <div>
//               <label className={labelCls} htmlFor="ic-email">
//                 Email *
//               </label>
//               <input
//                 id="ic-email"
//                 type="email"
//                 required
//                 value={form.email}
//                 onChange={update('email')}
//                 placeholder="you@company.com"
//                 className={inputCls}
//               />
//             </div>
//           </div>

//           <div className="grid gap-4 sm:grid-cols-2">
//             <div>
//               <label className={labelCls} htmlFor="ic-org">
//                 Organisation
//               </label>
//               <input
//                 id="ic-org"
//                 value={form.organisation}
//                 onChange={update('organisation')}
//                 placeholder="Company / Institution"
//                 className={inputCls}
//               />
//             </div>
//             <div>
//               <label className={labelCls} htmlFor="ic-country">
//                 Country
//               </label>
//               <input
//                 id="ic-country"
//                 value={form.country}
//                 onChange={update('country')}
//                 placeholder="e.g. United Arab Emirates"
//                 className={inputCls}
//               />
//             </div>
//           </div>

//           <div className="grid gap-4 sm:grid-cols-2">
//             <div>
//               <label className={labelCls} htmlFor="ic-phone">
//                 Phone
//               </label>
//               <input
//                 id="ic-phone"
//                 value={form.phone}
//                 onChange={update('phone')}
//                 placeholder="+91 00000 00000"
//                 className={inputCls}
//               />
//             </div>
//             <div>
//               <label className={labelCls} htmlFor="ic-subject">
//                 Subject *
//               </label>
//               <input
//                 id="ic-subject"
//                 required
//                 value={form.subject}
//                 onChange={update('subject')}
//                 placeholder="e.g. Trade delegation enquiry"
//                 className={inputCls}
//               />
//             </div>
//           </div>

//           <div>
//             <label className={labelCls} htmlFor="ic-message">
//               Message *
//             </label>
//             <textarea
//               id="ic-message"
//               required
//               rows={4}
//               value={form.message}
//               onChange={update('message')}
//               placeholder="Tell us how we can help…"
//               className={`${inputCls} resize-none`}
//             />
//           </div>

//           <button
//             type="submit"
//             className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#C0262D] px-6 py-3 text-[13px] font-bold text-white transition-colors hover:bg-[#a81f25] focus:outline-none focus:ring-2 focus:ring-[#C0262D]/30 sm:w-auto"
//           >
//             <FaPaperPlane className="h-3.5 w-3.5" />
//             Submit Query
//           </button>
//         </form>
//       )}
//     </motion.div>
//   );
// }

/* ==================== INTERNATIONAL CONTACT ==================== */
export default function InternationalContact() {
  return (
    <section
      id="contact"
      className="relative scroll-mt-20 overflow-hidden bg-gradient-to-b from-[#FAF7F2] to-[#FFFBF7] py-16 lg:py-20"
    >
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
      <div className="anim-st-blob anim-st-float-slow pointer-events-none absolute -left-24 bottom-8 h-64 w-64 bg-[#DA2128]/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid gap-10 lg:grid-cols-2">
          {/* ---------- LEFT: HEADING + CONTACT CARD ---------- */}
          <div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-3 inline-flex items-center gap-2"
            >
              <div className="h-[2px] w-6 rounded-full bg-[#DA2128]" />
              <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#DA2128]">
                Contact
              </span>
            </motion.div>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="mb-3 text-3xl font-bold leading-[1.1] tracking-tight text-stone-900 sm:text-4xl"
              style={SERIF}
            >
              Contact <span className="text-[#DA2128]">Us</span>
            </motion.h2>

            <p className="mb-6 text-base font-normal leading-relaxed text-[#241A16]/75">
              For queries related to International Affairs and global partnerships, reach out to the
              International Division. Our team will respond within 48 hours.
            </p>

            <motion.div
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.15 }}
              className="w-full max-w-md rounded-2xl border border-stone-100 bg-white p-5 font-sans shadow-sm"
            >
              <div className="space-y-5">
                {/* Contact Person */}
                <div className="flex items-start gap-3.5">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-sm font-bold text-[#C0262D]">
                    {CONTACT.name.charAt(0).toUpperCase()}
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-[14px] font-extrabold leading-snug text-stone-900">
                      International Affairs
                    </h4>
                    <p className="text-[14px] font-bold text-[#C0262D]">{CONTACT.name}</p>
                    <p className="text-[12px] text-stone-500">{CONTACT.title}</p>
                  </div>
                </div>

                {/* Address */}
                {/* <div className="flex items-start gap-3.5">
                  <a
                    href={mapsUrl(CONTACT.address)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
                  >
                    <FaRegBuilding className="h-4 w-4" />
                  </a>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-[14px] font-extrabold leading-snug text-stone-900">
                      {CONTACT.address.city
                        ? `Address (${CONTACT.address.city})`
                        : 'Address'}
                    </h4>
                    <div className="text-[12.5px] leading-relaxed text-stone-600">
                      {CONTACT.address.lines.map((line, i) => (
                        <span key={i} className="block">
                          {line}
                        </span>
                      ))}
                    </div>
                  </div>
                </div> */}

                {/* Email */}
                <div className="flex items-start gap-3.5">
                  <a
                    href={`mailto:${CONTACT.email}?subject=${encodeURIComponent(
                      'International Query'
                    )}`}
                    className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
                  >
                    <FaEnvelope className="h-4 w-4" />
                  </a>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-[14px] font-extrabold leading-snug text-stone-900">
                      Email
                    </h4>
                    <a
                      href={`mailto:${CONTACT.email}?subject=${encodeURIComponent(
                        'International Query'
                      )}`}
                      className="block truncate text-[13px] font-bold text-[#C0262D] hover:underline"
                    >
                      {CONTACT.email}
                    </a>
                    <p className="text-[11.5px] text-stone-500">
                      For queries related to International Affairs.
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start gap-3.5">
                  <a
                    href={`tel:${CONTACT.phoneHref}`}
                    className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
                  >
                    <FaPhone className="h-4 w-4" />
                  </a>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-[14px] font-extrabold leading-snug text-stone-900">
                      Phone Number
                    </h4>
                    <a
                      href={`tel:${CONTACT.phoneHref}`}
                      className="block text-[13px] font-bold text-[#C0262D] hover:underline"
                    >
                      {CONTACT.phone}
                    </a>
                    <p className="text-[11.5px] text-stone-500">
                      Mon–Fri, 9:30 AM – 6:00 PM IST
                    </p>
                  </div>
                </div>

                {/* WhatsApp intentionally hidden for International Division */}
              </div>
            </motion.div>
          </div>

          {/* ---------- RIGHT: QUERY FORM ---------- */}
          <QueryForm />
        </div>
      </div>
    </section>
  );
}